import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CheckCircle2, CalendarDays } from "lucide-react";
import axios from "axios";
import { BfgShell } from "@/game/gameShared";
import { memberApi } from "@/member/api";

const API = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "") + "/api";

export default function SupportedServiceThankYouPage(){
  const [params] = useSearchParams();
  const afterPayment = params.get("after_payment") === "1";
  const [bookingUrl, setBookingUrl] = useState("https://calendly.com/boardbuilder/recruitboard");
  useEffect(()=>{
    document.title="Thank You | Nonprofit Board Builder";
    if(!afterPayment) memberApi.post("/members/supported-service/handoff-complete").catch(()=>{});
    if(afterPayment) axios.get(API + "/admin/board-fundraising/public/sales-page")
      .then(response=>setBookingUrl(response.data.content?.facilitated_booking_url || "https://calendly.com/boardbuilder/recruitboard"))
      .catch(()=>{});
  },[afterPayment]);
  return <BfgShell><main className="bfg-flow" style={{maxWidth:720,margin:"0 auto",padding:"70px 20px 100px",textAlign:"center"}} data-testid="supported-service-thank-you">
    <section className="bfg-card" style={{padding:"38px 28px"}}>
      <CheckCircle2 size={58} color="#087f5b"/>
      <p className="bfg-eyebrow" style={{marginTop:16}}>{afterPayment?"PAYMENT CONFIRMED":"YOUR INFORMATION IS SAVED"}</p>
      <h1 style={{fontSize:"clamp(30px,5vw,44px)",lineHeight:1.1}}>{afterPayment?"Your Board Fundraising Game Engagement Is Confirmed":"Thank You. Rooney Will Take It From Here With You."}</h1>
      {afterPayment ? <>
        <p style={{fontSize:18,maxWidth:580,margin:"18px auto 0"}}>Your facilitated engagement with Rooney is confirmed. You can book your meeting below.</p>
        <p style={{marginTop:22,fontWeight:800}}>You do not need to complete organisation information now. Rooney will arrange the next steps and let you know when your organisation dashboard is ready to access.</p>
        {bookingUrl&&<a className="bfg-btn bfg-btn-primary" href={bookingUrl} target="_blank" rel="noreferrer" style={{marginTop:24,display:"inline-flex",alignItems:"center",gap:8}}><CalendarDays size={18}/>Book Your Meeting With Rooney</a>}
      </> : <>
        <p style={{fontSize:18,maxWidth:580,margin:"18px auto 0"}}>We have received the information needed to begin your supported process. Rooney will be in touch within the next 24 hours to confirm the next step and start working with you.</p>
        <p style={{marginTop:18,fontWeight:800}}>You do not need to complete anything else in the platform right now.</p>
      </>}
    </section>
  </main></BfgShell>;
}
